import axios from "axios";
import { detectDeviceOs } from "./deviceOs";
import { getClientIp } from "./clientIp";

const API_URL = "https://admuserjourney.api.adsctv.net/log";

const TIMEFRAME_MAP = {
  "-1": "minute",
  "0": "hour",
  "1": "day",
  "2": "week",
  "3": "month",
  "4": "epg",
  "5": "youtube",
  "6": "twitter",
  "99": "default",
};

export async function logUserInteraction({
  actionType,
  chartType,
  timeframeValue,
  details,
  channelId,
  channelName,
  userLanguage = "en",
  currentRoute,
  queryParams = {},
}) {
  try {
    const user = JSON.parse(localStorage.getItem("adm_panel_user"));
    if (!user) return;

    const tfKey = String(timeframeValue ?? 99);
    const timeframe = TIMEFRAME_MAP[tfKey] || "unknown";

    const payload = {
      action_type: actionType,
      chart_type: chartType,
      details,
      timeframe,
      timeframe_value: timeframeValue ?? 99,
      channel_id: channelId || "none",
      channel_name: channelName || "unknown",
      user_language: userLanguage,
      current_route: currentRoute || window.location.pathname,
      query_params: queryParams,
      platform: "web",
      device_os: detectDeviceOs(),
      client_ip: await getClientIp(),
    };

    const required = [
      payload.chart_type,
      payload.timeframe,
      payload.channel_id,
      payload.user_language,
    ];

    if (
      required.includes("unknown") ||
      required.includes("none") ||
      required.includes(undefined)
    ) {
      console.warn("UserJourney log skipped:", payload);
      return;
    }

    const res = await axios.post(API_URL, payload, {
      headers: {
        Token: localStorage.getItem("adm_panel_token"),
      },
    });


    // Log the full payload and status for debugging
    console.log("UserJourney FULL LOG:", { ...payload, status: res.status });

    return res.data;
  } catch (err) {
    console.error(
      "UserJourney log failed:",
      err?.response?.data || err.message
    );
  }
}
